<template>
  <div class="pins">
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
    <div class="di">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          class="yuhujf"
        >
          <img src="../../assets/img/famous-teacher-studio.png" width="100%"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div>
      <van-row
        gutter="10"
        class="mag"
        v-for="(list, index) in arr"
        :key="index"
        @click="dianjis(list.id)"
      >
        <van-col span="8" class="famous-teacher-studio-img-row">
          <img
            :src="list.serverHttp+list.headPhotoUrl"
            width="100%"
            class="famous-teacher-studio-img"
            v-if="list.headPhotoUrl&&list.headPhotoUrl!==''"
          />
          <img
            src="../../assets/img/zbmr.png"
            width="100%"
            class="kecimg"
            v-else
          />
        </van-col>
        <van-col span="16">
          <van-col span="24" class="heise " style="max-width: 100%; font-size: 12px !important;">
            {{ list.schoolName }} |
            {{ list.name }}名师工作室
          </van-col>
          <van-col span="24" style="margin-top: 10px;font-size: 11px !important;">
            <van-col span="24">
              <span style="display: -webkit-box;overflow: hidden;text-overflow: ellipsis;word-break: break-all;-webkit-box-orient: vertical;-webkit-line-clamp: 4;color: dimgray;">{{ list.introduction }}</span>
            </van-col>
          </van-col>
        </van-col>
      </van-row>

    </div>
    <dibu class="dibu"></dibu>
  </div>
</template>

<script>
import {famous_teacher_list} from "@/api/home";
import dibu from "@/components/index/di";

export default {
  data() {
    return {
      index: null,
      show: false,
      curPage: 1,
      courlist: [],
      endDate: '',
      beginDate: '',
      arr: [],
      imglist: [],
      img: require("../../assets/img/kong.png"),
    };
  },
  watch: {},
  components: {dibu},
  methods: {
    courselist() {
      let that = this;
      that.show = true;
      let params = {
        curPage: this.curPage,
        pageSize: 10,
        courseState: 1,
        // courseTypeid: 2,
        groupId: 1,
        courseClassify: this.index,
        isHaveHour: 1
      };
      famous_teacher_list(params)
        .then((res) => {
          that.arr = res.data.data.dataList
          that.show = false;
        })
        .catch(() => {
          that.show = false;
        });
    },
    dianjis(s) {
      this.$router.push({
        path: "/course",
        query: {
          id: this.index,
          famousTeacherId: s,
        },
      });
    },
    dianji(s) {
      this.$router.push({
        path: "/video",
        query: {
          id: s,
          t: Date.now()
        },
      });
    },
  },
  mounted() {
    this.index = this.$route.query.id;
    this.courselist()
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/studio.vue